/* Copyright (c) 2020-present CloudIO Inc */

import React, { ReactPortal, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

type Props = {
  node?: Element | null;
  children: React.ReactNode;
};

export function Portal({ node, children }: Props): ReactPortal | null {
  const [el, setEl] = useState(node);

  useEffect(() => {
    if (!node) {
      const div = document.createElement('div');
      document.body.appendChild(div);
      setEl(div);
      return () => {
        if (div) {
          document.body.removeChild(div);
        }
      };
    }
  }, [node]);

  if (!canUseDOM) {
    return null;
  }

  return el != null ? createPortal(children, el) : null;
}

export default Portal;
